// extracted by mini-css-extract-plugin
export default {"wrap":"ClientsPage_wrap__0Y3gO"};